export const selectContentBar = state => state.ui;
